import React, { useState, useEffect } from "react";
import {
    IonRadioGroup,
    IonRadio,
    IonItem,
    IonLabel,
} from "@ionic/react";

// Define question types
type QuestionType = "multipleChoice";

interface MultipleChoiceQuestion {
    question: string;
    options: string[];
    correct: string;
}

// import the JSON data

const Gender: React.FC = () => {
    const [currentQuestion, setCurrentQuestion] = useState<MultipleChoiceQuestion | null>(null);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [isCorrect, setIsCorrect] = useState(false);
    const [showImage, setShowImage] = useState(false);

    const [questionBank, setQuestionBank] = useState<Record<QuestionType, MultipleChoiceQuestion[]>>({
        multipleChoice: [],
    });

    const fetchQuestions = async () => {
        try {
            let multipleChoiceQuestion: MultipleChoiceQuestion[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {

                const response1 = await fetch(process.env.REACT_APP_API_URL + 'GenderClassTwoMCQ.json');
                multipleChoiceQuestion = await response1.json();

            } else {

                const module1 = await import('../../../datas/GenderClassTwoMCQ.json');
                multipleChoiceQuestion = module1.default;
            }
            setQuestionBank({
                multipleChoice: multipleChoiceQuestion as MultipleChoiceQuestion[], // ✅ type casting
            });
        } catch (error) {
            console.error("Error loading questions:", error);
        }
    };

    useEffect(() => {
        fetchQuestions();
        document.title = "Mamas Guidance - Class Two - English - Gender"; // Set page title
    }, []);

    useEffect(() => {
        if (questionBank.multipleChoice.length) {
            getRandomQuestion();
        }
    }, [questionBank]);

    const getRandomQuestion = () => {
        const questionTypes = Object.keys(questionBank) as QuestionType[];
        const randomType = questionTypes[Math.floor(Math.random() * questionTypes.length)];
        const randomQuestion = questionBank[randomType][Math.floor(Math.random() * questionBank[randomType].length)];
        setCurrentQuestion(randomQuestion);
        setSelectedOption(null);
    };

    const handleAnswerSubmit = (option: string) => {
        setSelectedOption(option);
        if (!currentQuestion) return;

        if (option === currentQuestion.correct) {
            setIsCorrect(true);
            showNextQuestion();
        } else {
            setIsCorrect(false);
        }
    };

    const showNextQuestion = () => {
        setShowImage(true);
        setTimeout(() => {
            setShowImage(false);
            setSelectedOption(null);
            getRandomQuestion();
            setIsCorrect(false);
        }, 5000);
    };

    // ✅ Correct typing for TextWithBold props
    const TextWithBold: React.FC<{ text: string }> = ({ text }) => {
        const parts = text.split(/\*\*(.*?)\*\*/);

        return (
            <h3 className="mb-3">
                {parts.map((part, index) =>
                    index % 2 === 1 ? <strong key={index}>{part}</strong> : part
                )}
            </h3>
        );
    };

    return (
        <>
            {!showImage ? (
                <div className="contentPart showCenter fillPreposition additionWord">
                    {currentQuestion ? (
                        <>
                            <TextWithBold text={currentQuestion.question} />

                            <IonRadioGroup onIonChange={(e) => handleAnswerSubmit(e.detail.value)}>
                                {currentQuestion.options.map((option, index) => (
                                    <IonItem
                                        className={`grid-item ${selectedOption === option
                                            ? isCorrect
                                                ? "correct"
                                                : "errorItems"
                                            : ""
                                            }`}
                                        key={index}>
                                        <IonRadio slot="start" value={option} />
                                        <IonLabel>{option}</IonLabel>
                                    </IonItem>
                                ))}
                            </IonRadioGroup>
                        </>
                    ) : (
                        <p>Loading question...</p>
                    )}
                </div>
            ) : (
                <div className="contentPart showMiddle">
                    <img
                        style={{ height: "150px" }}
                        className="img-fluid"
                        src={process.env.REACT_APP_WELDONE_LINK}
                        alt="Congratulations"
                    />
                </div>
            )}
        </>
    );
};

export default Gender;
